import { HttpMethod } from '../Common/useFetch';
import { RequestOptions } from '../Common/useRequest';
import useUserRequest from '../Common/useUserRequest';
import { useSelectedBusiness } from '../UserAccess/useSelectedBusiness';
import { UserRoleUpsertDto } from './useGetUsers';

const userRolesPath = (businessId: string) => `/api/businesses/${businessId}/userRoles`;

export const useCreateUserRole = (options?: RequestOptions<void>) => {
  const business = useSelectedBusiness();
  return useUserRequest<UserRoleUpsertDto>(
    { path: userRolesPath(business.id), method: HttpMethod.POST },
    options);
};

export const useUpdateUserRole = (userRoleId: string, options?: RequestOptions<void>) => {
  const business = useSelectedBusiness();
  return useUserRequest<UserRoleUpsertDto>(
    { path: `${userRolesPath(business.id)}/${userRoleId}`, method: HttpMethod.PUT },
    options);
};
